import { gql } from '@apollo/client';

export const GET_APPOINTMENTS = gql`
  query GetAppointments($input: GetAppointmentsInput) {
    appointments: getAppointments(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
          date
          time
          description
          notes
          status
          followUpAppointment
          walkIn
          flagged
          practitioner {
            id
            firstName
            lastName
          }
          consultationTypes {
            id
            name
          }
          consultation {
            id
          }
          case {
            id
            caseId
            peopleProfile {
              id
              firstName
              lastName
            }
          }
          categories {
            id
            name
          }
        }
      }
    }
  }
`;
